import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import moreInfoIcon from '/src/assets/moreInfoIcon.svg';
import closeBotIcon from '/src/assets/closeBotIcon.svg';
import reloadIcon from '/src/assets/reloadIcon.svg';
import clsx from 'clsx';

export default function ChatHeaderChatbot({
    modeChatbot, welcomeNavigationStateChatbot, resetChatbotFunc, isOpen,
    navigationState, welcomeNavigationState 
  }) {
    
  function getFormattedDate(date) {
    const now = new Date(date);
    return `Hoy, ${format(now, 'hh:mm aaa', { locale: es })}`;
  }

  function handlerClick() {
    isOpen.value = !isOpen.value;
    document.documentElement.classList.remove('bot-utn-no-scroll');
    document.documentElement.classList.add('bot-utn-scroll');
    document.body.classList.remove('bot-utn-no-scroll');
    document.body.classList.add('bot-utn-scroll');
  }

  const backgroundWhite = modeChatbot === 'recommender' && welcomeNavigationStateChatbot == 2 ? "background:white;" : ''

  return (
    <div className='bot-utn-container-chat-header'>
      <div className='bot-utn-left-chat-header'>
        {navigationState.value === 0 ? <span title="Chatbot" className='bot-utn-typography-01'>CeL.ia Chat bot</span> :
          <span title="Recomendador" className='bot-utn-typography-01-recommender'>CeL.ia Recomendador</span>
        }
      </div>
      <div className='bot-utn-right-chat-header'>
        {(modeChatbot === 'chatbot' || 
         welcomeNavigationStateChatbot === 2) && 
          <div className='bot-utn-header-container-icon bot-utn-tooltip' style={`${backgroundWhite}`} title="Nueva conversacion" onClick={resetChatbotFunc}>
            <img 
              src={reloadIcon}
              alt='reload icon'
              className="bot-utn-header-icon-img"
            />
            <span className="bot-utn-tooltip-text">Nueva conversación</span>
          </div>
        }
        <a style={`${backgroundWhite}`} title="Ayuda" href="https://centrodeelearning.my.site.com/ayuda/s/" target="_blank" className='bot-utn-header-container-icon'>
          <img 
            src={moreInfoIcon} 
            alt='question logo' 
            className="bot-utn-header-icon-img"
          />
        </a>
        <div className='bot-utn-header-container-close-icon' onClick={handlerClick}>
          <img 
            src={closeBotIcon} 
            alt='close logo' 
            height='18' 
            width='18' 
          />
        </div>
      </div>
      {navigationState.value === 0 || (navigationState.value === 1 && welcomeNavigationState.value === 2) ?
        <span title={`${getFormattedDate(new Date())}`} className='bot-utn-typography-02'>{getFormattedDate(new Date())}</span> : ''
      }
    </div>
  )
}
